// Argus — Watched Paths modal (wrap WatchedPathsPage in Dialog).
// Bloc v1.0.10 #D — 2026-05-07.

import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAdminModalsStore } from '../../store/adminModalsStore';
import { WatchedPathsPage } from '../../pages/admin/WatchedPathsPage';

export function WatchedPathsModal(): JSX.Element {
  const open = useAdminModalsStore((s) => s.watchedPathsOpen);
  const close = useAdminModalsStore((s) => s.closeWatchedPaths);

  return (
    <Dialog open={open} onClose={close} maxWidth="lg" fullWidth scroll="paper" slotProps={{ paper: { sx: { height: '85vh' } } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Watched Paths
        <IconButton onClick={close} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ p: 2 }}>
          <WatchedPathsPage />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
